module.exports = __webpack_public_path__ + "img/1566662056.fc55e246.jpg";